export enum ModalType {
    MY_BETS,
    COUPONS
}